module.exports = __webpack_public_path__ + "img/green_073.8c2135ed.png";